import moment from 'moment';
import {BonusQuestionListItem, BonusQuestionStatus} from './types';

export const computeBonusQuestionStatus = (
  question: BonusQuestionListItem,
  /** Seule la fin de journée compte ici ; vient du calendrier complet. */
  gameWeek: {endDate?: string} | undefined,
  now = moment(),
): BonusQuestionStatus => {
  if (question.status === 'draft') return 'draft';
  if (question.status === 'cancelled') return 'cancelled';
  if (question.status === 'resolved') return 'finished';

  const {visibilityStartsAt, answerDeadlineAt, isVisible} = question;
  const gameWeekEndDate = gameWeek?.endDate;

  if (gameWeekEndDate && !now.isBefore(gameWeekEndDate)) return 'toClose';
  if (answerDeadlineAt && !now.isBefore(answerDeadlineAt)) return 'live';
  if (visibilityStartsAt && !now.isBefore(visibilityStartsAt) && isVisible) {
    return 'open';
  }
  // Avant la diffusion, ou dates manquantes : la question n'est pas encore sur l'app.
  return 'scheduled';
};



// WEBPACK FOOTER //
// ./src/pages/Other/MPP/QuestionBonus/status.ts